import { getInitials, getAMCLogoURL } from "creso-core/utils";
import { getCurrentEnvironment } from "@/utils/common";
import { cn } from "web-design-system";
import { Avatar } from "web-core";

export function AmcLogo({
  amc_code,
  size = "sm",
  className,
}: {
  amc_code: string | null;
  className?: string;
  size?: "sm" | "lg" | "default";
}) {
  return (
    <Avatar
      className={cn(className, "bg-background dark:bg-background")}
      url={getAMCLogoURL(amc_code, getCurrentEnvironment())}
      fallback={getInitials(amc_code || "")}
      size={size}
    />
  );
}
